import { EBuyPackageStatus, TDispatch, TGetState } from '../../types';
import { setBuyPackageModalStatus } from '../../slices';
import { payPackageThunk } from '../payPackage';
import { selectIsHoldAvailable } from '../../selectors';

export const notEnoughMoneyThunk = () => (dispatch: TDispatch, getState: TGetState) => {
  const state = getState();

  if (selectIsHoldAvailable(state)) {
    dispatch(payPackageThunk());
  } else {
    dispatch(setBuyPackageModalStatus(EBuyPackageStatus.NotEnoughMoney));
  }
};
